import React, { useId } from 'react';

const Icon = ({ size = '57', fill = '#FFEFBC', ...other }) => {
    const id = useId();
    const gradientA = `earnIcon-gradient-a-${id}`;

    return (
        <svg width={size} height={size} viewBox="0 0 57 57" fill="none" {...other}>
            <circle cx="25.445" cy="25.445" fill={fill} stroke={`url(#${gradientA})`} strokeWidth="2" r="24.445" />

            <path
                d="M7.204 18.87H21.95M7.204 33.904H21.95m6.806-15.034H43.5M7.204 26.59H21.95m6.806 7.836v-6.815c0-.564.507-1.02 1.134-1.02H43.5"
                stroke="#E7BD7C"
                strokeWidth="2"
                strokeLinecap="round"
            />

            <path
                d="M32.11 47.44 32 43.626c0-.345.28-.625.625-.625h21.4a1 1 0 0 1 1 .974l.087 3.438a1 1 0 0 1-.8 1.005L49.1 49.481a1 1 0 0 1-.2.02h-9.776a.996.996 0 0 1-.178-.016l-6.014-1.09a1 1 0 0 1-.821-.955Z"
                fill={fill}
            />

            <path
                d="M32 51.695V48.75a.75.75 0 0 1 .75-.75H54a1 1 0 0 1 1 1v2.715a1 1 0 0 1-.762.971l-5.254 1.285a1 1 0 0 1-.238.029h-9.739a.998.998 0 0 1-.212-.023l-6.007-1.306a1 1 0 0 1-.788-.977Z"
                fill={fill}
            />

            <path
                d="M43.5 44.796c6.444 0 11.668-1.45 11.668-3.24 0-1.79-5.224-3.241-11.667-3.241-6.444 0-11.667 1.45-11.667 3.24 0 1.79 5.223 3.241 11.667 3.241Z"
                fill={fill}
                stroke="#D2A160"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M31.834 46.092c0 2.148 5.223 3.89 11.667 3.89 6.443 0 11.667-1.742 11.667-3.89m-23.334 5.185c0 2.148 5.223 3.89 11.667 3.89 6.443 0 11.667-1.742 11.667-3.89m0-10.37v10.37m-23.334-10.37v10.37"
                stroke="#D2A160"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <defs>
                <linearGradient id={gradientA} x1="25.445" y1="1" x2="25.445" y2="49.89" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCDA98" />

                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
